import { useField } from 'formik';
import { ticketFieldLabelClass } from '../core/_utils';
import TicketFieldHint from './TicketFieldHint';

type Props = {
  name: string;
  label: string;
  required?: boolean;
  help?: string;
};

const TicketYesNoField = ({ name, label, required = false, help }: Props) => {
  const [yesField, meta] = useField({ name, type: 'radio', value: 'Sim' });
  const [noField] = useField({ name, type: 'radio', value: 'Não' });
  const legendClass = `${ticketFieldLabelClass(required)} float-start w-auto mb-0 p-0`;
  const error = meta.touched ? meta.error : undefined;
  const hasHint = Boolean(help || error);

  return (
    <fieldset className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-5">
      <legend className={legendClass}>{label}</legend>
      <div className="d-flex gap-6">
        <label className="form-check form-check-custom form-check-solid form-check-sm">
          <input className="form-check-input" type="radio" {...yesField} />
          <span className="form-check-label text-gray-700">Sim</span>
        </label>
        <label className="form-check form-check-custom form-check-solid form-check-sm">
          <input className="form-check-input" type="radio" {...noField} />
          <span className="form-check-label text-gray-700">Não</span>
        </label>
      </div>
      {hasHint ? (
        <div className="w-100">
          <TicketFieldHint error={error} help={help} />
        </div>
      ) : null}
    </fieldset>
  );
};

export default TicketYesNoField;
